/**
 * Where a page finds its token. Links have taken several shapes over time and
 * every one already sent must keep working.
 */

/** The last path segment: /read/<token>, /sign-only/<token>, /<token>. */
export function lastSegment(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  return parts[parts.length - 1] || "";
}

/**
 * The signing page's token: `?token=` when it looks like a real one (32 hex
 * characters — a stale `?token=sign` test URL must not win), else the path's
 * last segment (/sign/<token>).
 */
export function signToken(search, pathname) {
  const query = new URLSearchParams(search).get("token");
  if (query && /^[0-9a-f]{32}$/i.test(query)) return query;
  const last = lastSegment(pathname);
  return last && last !== "sign" ? last : "";
}

/** The read page's token: `?token=`, else the last path segment (/read/<token>). */
export function readToken(search, pathname) {
  const last = lastSegment(pathname);
  return new URLSearchParams(search).get("token") || (last !== "read" ? last : "");
}

/**
 * The upload page's token: the whole path after "/" (/<token>), or none on a
 * public form link (`/?form=<slug>`), where the request does not exist yet.
 */
export function uploadToken(search, pathname) {
  if (new URLSearchParams(search).get("form")) return "";
  return pathname.replace(/^\/+/, "").trim();
}
